import documentReducer from "./reducers";

export default documentReducer;
